module.exports = __webpack_public_path__ + "img/gtsfly-logo.25dad5d8.svg";